export class Config {
  static get isProduction(): boolean {
    return ["production"].includes(process.env.NODE_ENV || "");
  }
}
